import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type EmailEventListItem = ResultOf<
  typeof allEmailEventsQuery
>["allEmailEvents"]["data"][number];

export const allEmailEventsQuery = graphql(`
  query AllEmailEvents(
    $first: Int!
    $page: Int
    $recipient: String
    $status: [EmailEventStatus!]
    $type: [EmailType!]
    $orderBy: [QueryAllEmailEventsOrderByOrderByClause!]
  ) {
    allEmailEvents(
      first: $first
      page: $page
      recipient: $recipient
      status: $status
      type: $type
      orderBy: $orderBy
    ) {
      data {
        id
        recipient
        type
        message_id
        status
        failure_reason
        failure_code
        created_at
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);
